<div elementDataTest="subtitlesLanguageElement">
    <app-forms-dropdown-ac
        [items]="languagesItems"
        formClass="w-100"
        [control]="languageControl"
        widthSize="full"
        displayType="bottom-with-space-lang"
        formControlDataTest="language"
        [placeholder]="placeholder"
        [isDisabled]="isDisabled"
    ></app-forms-dropdown-ac>
</div>
